import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Switch, BrowserRouter, Route, Redirect } from 'react-router-dom'
import ForgotPassword from 'components/ForgotPassword'
import LoginPage from 'components/LoginPage'
import NotFound from 'components/NotFound'
import MainBar from 'components/Navigation/MainBar'
import Invite from 'components/Invite'
import TabbedRoutes from 'components/App/TabbedRoutes'
import CommunityPage from 'components/CommunityPage'
import MyGivingPage from 'components/MyGivingPage'
import { refreshUserData } from 'actions/users'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import Notifications from 'components/Notifications'
import StripeConnectRedirect from 'components/stripe/StripeConnectRedirect'
import PrivateRoute from 'components/App/PrivateRoute'
import InauthenticatedOnlyRoute from 'components/App/InauthenticatedOnlyRoute'
import SupporterOnboarding from 'components/SupporterOnboarding'
import Financial from 'components/Settings/Financial'
import Personal from 'components/Settings/Personal'
import BackdropLoader from 'components/BackdropLoader'

const App = () => {
  const dispatch = useDispatch()
  const userId = useCurrentUserProp('id')
  const currentSignInAt = useCurrentUserProp('currentSignInAt')
  useEffect(() => {
    const minsSinceLogin = Math.round((((new Date() - new Date(currentSignInAt)) % 86400000) % 3600000) / 60000)
    if(userId && minsSinceLogin > 1) {
      dispatch(refreshUserData(userId))
    }
  }, [userId, dispatch, currentSignInAt])

  return (
    <BrowserRouter>
      <MainBar />
      <Notifications />
      <BackdropLoader />
      <Switch>
        <Redirect from='/' exact to='/home' />
        <Route path='/stripe-connect-redirect' exact component={StripeConnectRedirect} />
        {/* TODO: this could become the route used for authenticated users as well to change their pw */}
        <InauthenticatedOnlyRoute withContainer={false} exact path='/forgot-password' component={ForgotPassword} />
        <InauthenticatedOnlyRoute withContainer={false} exact path='/login' component={LoginPage} />
        <InauthenticatedOnlyRoute exact path='/invite/:communityId' component={Invite} />
        <PrivateRoute path='/supporter-onboarding' component={SupporterOnboarding} />
        <PrivateRoute withContainer={false} path='/home' component={HomeRoutes} />
        <PrivateRoute withContainer={false} path='/settings' component={SettingRoutes} />
        <Route path='*' exact component={NotFound} />
      </Switch>
    </BrowserRouter>
  )
}

const HomeRoutes = () => (
  <TabbedRoutes
    routes={[
      { path: 'community', label: 'community', component: CommunityPage },
      { path: 'my-giving', label: 'my giving', component: MyGivingPage}
    ]}
  />
)

const SettingRoutes = () => (
  <TabbedRoutes
    routes={[
      { path: 'financial', label: 'financial', component: Financial },
      { path: 'personal', label: 'personal', component: Personal }
    ]}
  />
)

export default App
